import React, { useState, useRef, useMemo, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import * as Yup from "yup";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { IoIosInformationCircle, IoMdAddCircle } from "react-icons/io";
import { Product } from "../../../../common/imagePath";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import config from "../../../../config/config";
import { uploadAWS } from "../../../../common/AWSHelper";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER,
  AWS_IMAGE_FOLDER_CATEGORIES,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import FileInput from "../../../../components/FormControls/FileInput";
import { toastError, toastSuccess } from "../../../../common/Toast";

const ItemInfo = (props) => {
  const buttonRef = React.useRef();

  const navigate = useNavigate();
  const selectRef = useRef(null);
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const paramObject = useParams();
  const [changeImagename, setChangeImagename] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedParentCategory, setselectedParentCategory] = useState(0);
  const [selectedCategory, setselectedCategory] = useState(0);
  const [selectedSecondaryCategory, setselectedSecondaryCategory] = useState(0);
  const [btnLoader, setBtnLoader] = useState({ Imagename: false });
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [data, setData] = useState([]);
  const [SecondCategories, setSecondCategories] = useState([]);
  const [locationsData, setLocationsData] = useState([]); //store loaction from api response
  const [selectedItems, setSelectedItems] = useState([]);
  const [suppliers, setsuppliers] = useState([]);
  const [category, setCategory] = useState([{ ID: 0, CategoryId: "" }]);
  const [supplier, setSupplier] = useState([{ ID: 0, SupplierId: "" }]);
  const [modifier, setModifier] = useState([{ ID: 0, ModifierId: "" }]);
  const [show, setShow] = useState(false); //Show the Categories model
  const [Modifiers, setModifiers] = useState([]);
  const [check, setCheck] = useState([]);
  const [selectedModifiers, setSelectedModifiers] = useState([]);
  const [ItemFieldshow, setItemFieldshow] = useState(false);

  const ActionButtons = (props) => {};
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  // const handleNext = () => {
  //   props.nextStep();
  //   window.scrollTo(0, 0);
  // };

  const validationSchema = Yup.object().shape({
    ItemKitName: Yup.string().required("Name is required"),
    //UpcName: Yup.string().required("UPC/EAN/ISBN is required"),
  });

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  const [formValues, setFormValues] = useState({
    UpcName: "",
    ItemKitName: "",
    BarcodeName: "",
  });

  const addCategory = () => {
    const rowsInput = {
      ID: 0,
      CategoryId: "",
    };

    setCategory([...category, rowsInput]);
  };

  const addSupplier = () => {
    const rowsInput = {
      ID: 0,
      SupplierId: "",
    };
    setSupplier([...supplier, rowsInput]);
  };

  var isCheck = (item) =>
    check.includes(item.ID) ? "checked-item" : "not-checked-item";

  let ParentCategoryOption = [];
  const ItemKits = data.map((u, i) => {
    ParentCategoryOption[i] = { label: u.Name, value: u.ID };
  });

  let Catagories = [];
  const ItemCategories = SecondCategories.map((u, i) => {
    Catagories[i] = { label: u.Name, value: u.ID };
  });

  //Supplies comma separated
  let Supplierlist = [];
  const Supplierlists = suppliers.map((u, i) => {
    Supplierlist[i] = { label: u.FirstName, value: u.ID };
  });

  let Modifierlist = [];
  const Modifierlists = Modifiers.map((u, i) => {
    Modifierlist[i] = { label: u.Name, value: u.ID };
  });

  // handel for Categories
  const handleChangeforDropdon = (index, event) => {
    let name, values;
    name = "CategoryId";
    values = event.value;

    const cardInput = [...category];
    cardInput[index][name] = values;

    setCategory(cardInput);
  };

  const handleChangeforDropdonsuppliers = (index, event) => {
    let name, values;
    name = "SupplierId";
    values = event.value;

    const cardInput = [...supplier];
    cardInput[index][name] = values;

    setSupplier(cardInput);
  };

  // close and show model pop
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  /* AWS FILE UPLOAD */
  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const vaidation = (name, value) => {
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_CATEGORIES, (data) => {
      if (data) {
        setImageUrl(data);
        setLoading(false);
      }
    });
  };

  const handleCheck = (index, evnt, id) => {
    if (id > 0) {
      if (evnt.target.checked) {
        // add the ID to the check state
        setCheck([...check, id]);
      } else {
        // remove the ID from the check state
        setCheck(check.filter((item) => item !== id));
      }
    }
  };
  // Model Processs
  // model validations
  const validationSchemaformodel = Yup.object().shape({
    CategoryName: Yup.string().required("Name is required"),
  });

  const [formValuesformodel, setFormValuesformodel] = useState({
    ID: 0,
    CategoryName: "",
    Hidefromgrid: "",
    ParentID: 0,
    Color: "",
    Ecommerce: "",
    Imagename: "",
    CategoryInfopopup: "",
  });

  const handleDropdownData = (CategorieData) => {
    setLoading(true);
    //for model bind the cetegoires
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setData(res.data.ResponseData);
        setSecondCategories(res.data.ResponseData);
        if (CategorieData != undefined) {
          // Binding Category data
          let CategorieList = res.data.ResponseData;

          CategorieList.map((selectedCategory) => {
            if (selectedCategory.ID == CategorieData) {
              setselectedCategory({
                label: selectedCategory.Name,
                value: selectedCategory.ID,
              });
            }
          });
        }
      });

    axios
      .get(`${config.modifiersBaseUrl}/modifiers/selectall`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // setLoading(false);

        setModifiers(res.data.ResponseData);
      })
      .catch((err) => {
        // setLoading(false);
      });

    // for bind loactions in model
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationsData(res.data.ResponseData);

        // setLoading(false);
        return res;
      });

    // supplier dropdown
    axios
      .get(`${config.suppliersBaseUrl}/suppliers/dropdownsupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setsuppliers(res.data.ResponseData);

        return res;
      });

    setLoading(false);
  };

  //locations comma separated
  let itemkitsOption = [];
  const modelitem = locationsData.map((u, i) => {
    itemkitsOption[i] = { label: u.Name, value: u.Id };
  });

  // handel for Loactions select and set comma separated
  const handleItemKitsIds = (e) => {
    setSelectedItems(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  const handleModifierSelection = (e, ID) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedModifiers((prevState) => [...prevState, ID]);
    } else {
      setSelectedModifiers((prevState) => prevState.filter((id) => id !== ID));
    }
  };

  //handlesubmit for categories
  const handleSubmitformodel = async (eventObject) => {
    setLoading(true);
    axios
      .post(
        `${config.categoriesBaseUrl}/categories/upsert`,
        {
          id: eventObject.ID,
          name: eventObject.CategoryName,
          hidefromgrid: selectedItems.toString(),
          parentid: eventObject.ParentID,
          imagename: ImageUrl,
          color: eventObject.Color,
          categoryinfopopup: eventObject.CategoryInfopopup,
          loginuserid: loginUserId,
        },

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          const clearData = {
            ID: 0,
            Name: "",
            Hidefromgrid: false,
            ParentID: 0,
            Color: "",
            Imagename: "",
            CategoryInfopopup: "",
          };
          setFormValuesformodel(clearData);
          handleDropdownData(res.data.ResponseID);
          setImageUrl("");
          setShow(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  const handleSubmit = (value) => {
    let categoryIdArray = category.map((itemkits) => itemkits.CategoryId);
    let supplierIdArray = supplier.map((itemkits) => itemkits.SupplierId);
    let Itemkits = {};

    if (paramObject.id === undefined) {
      Itemkits = {
        id: 0,
        itemkitnumber: value.UpcName,
        name: value.ItemKitName,
        barcodename: value.BarcodeName,
        categoryid: selectedCategory.value,
        loginuserid: loginUserId,
        secondarycategoryIds: categoryIdArray.toString(),
        supplierIds: supplierIdArray.toString(),
        modifierIds: "",
      };
      console.log("Itemkits", Itemkits);
    } else {
      Itemkits = {
        id: paramObject.id,
        itemkitnumber: value.UpcName,
        name: value.ItemKitName,
        barcodename: value.BarcodeName,
        categoryid: selectedCategory.value,
        loginuserid: loginUserId,
        secondarycategoryIds: categoryIdArray.toString(),
        supplierIds: supplierIdArray.toString(),
        modifierIds: check.toString(),
      };
      console.log("Itemkits", Itemkits);
    }

    axios
      .post(`${config.itemKitsBaseUrl}/itemkits/upsert`, Itemkits, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          if (paramObject.id === undefined) {
            const ItemKitID = res.data.ResponseID;
            // navigate("/error403");
            navigate(`/manage-item-Kits/${ItemKitID}`);
            //window.location.reload();
          } else {
            props.nextStep();
            window.scrollTo(0, 0);
          }
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  //data binding
  useEffect(() => {
    if (paramObject.id > 0) {
      setLoading(true);
      setItemFieldshow(false);
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/iteminfofindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData);
          if (res.data.ResponseCode === "SUCCESS") {
            const modifierIds = res.data.ResponseData.Modifiers?.map(
              (modifier) => [modifier.ModifierId.toString()]
            );
            const newArray = modifierIds?.map((str) => parseInt(str, 10));
            setCheck(newArray);
            let data = res.data.ResponseData.ItemKits[0];
            const itemkitsdata = {
              UpcName: data.Itemkitnumber,
              ItemKitName: data.Name,
              BarcodeName: data.Barcodename,
            };

            setCategory(res.data.ResponseData.Catagories);
            setSupplier(res.data.ResponseData.Suppliers);
            setModifier(res.data.ResponseData.Modifiers);
            setFormValues(itemkitsdata);
            handleDropdownData(res.data.ResponseData.ItemKits[0].CategoryId);

            setLoading(false);
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
            setLoading(false);
          } else {
            toastError(ERROR_MESSAGE);
            setLoading(false);
          }
        });
    } else {
      setItemFieldshow(true);
      handleDropdownData();
    }
  }, []);

  // $("#btn1").click(function () {
  //   inputElement.click();

  //   // $("#btn2").trigger("click");
  //   // console.log("Button 1 clicked and Button 2 triggered");

  //   // if ($("#btn2").data("page") === "specific-page") {
  //   //   $("#btn2").trigger("click");
  //   //   console.log("Button 1 clicked and Button 2 triggered");
  //   // }
  //   // return false;
  // });

  function handleButtonClick() {
    if (buttonRef.current.getAttribute("data-page") === "specific-page") {
      buttonRef.current.click();
      console.log("Button 1 clicked and Button 2 triggered");
    }
  }

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="card">
        <Formik
          {...props}
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title">
              Item Information (Fields in <span className="text-danger">*</span>
              are required)
            </h5>
            {ItemFieldshow === false && (
              <div>
                {props.currentStep < props.totalSteps && (
                  <button
                    //   onClick={handleNext}
                    className="btn btn-primary btn-md"
                    id="btn1"
                    type="button"
                    onClick={handleButtonClick}
                  >
                    Next
                  </button>
                )}
              </div>
            )}
          </div>
        </Formik>
        <Formik
          {...props}
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, handleChange }) => (
            <Form>
              <div className="card-body">
                <div className="row">
                  {/* UPC/EAN/ISBN */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-2">
                        UPC/EAN/ISBN
                      </label>
                      <div className="col-md-10">
                        <Field
                          type="text"
                          // className={`form-control ${
                          //   errors.UpcName ? "is-invalid" : ""
                          // }`}
                          className="form-control"
                          name="UpcName"
                          id="UpcName"
                          onChange={handleChange}
                        />
                        {/* <div className="invalid-feedback">
                          {touched.UpcName && errors.UpcName
                            ? errors.UpcName
                            : ""}
                        </div> */}
                      </div>
                    </div>
                  </div>

                  {/* Item Name */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-2">
                        Item Kit Name<span className="text-danger">*</span>
                      </label>
                      <div className="col-md-10">
                        <Field
                          type="text"
                          // className="form-control"
                          className={`form-control ${
                            errors.ItemKitName ? "is-invalid" : ""
                          }`}
                          name="ItemKitName"
                          id="ItemKitName"
                          onChange={handleChange}
                        />
                        <div className="invalid-feedback">
                          {touched.ItemKitName && errors.ItemKitName
                            ? errors.ItemKitName
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Barcode Display Name */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-2">
                        Barcode Display Name
                      </label>
                      <div className="col-md-10">
                        <Field
                          type="text"
                          className="form-control"
                          name="BarcodeName"
                          id="BarcodeName"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Category */}
                <div className="row mt-3">
                  <label className="col-form-label col-md-1">
                    Category<span className="text-danger">*</span>
                  </label>
                  <div className="col-md-11">
                    <Select
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      onChange={setselectedCategory}
                      options={ParentCategoryOption}
                      placeholder=""
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={
                        ParentCategoryOption.find(
                          (option) => option.value === selectedCategory.value
                        ) || ""
                      }
                      id="Category"
                      name="Category"
                      className="w-100"
                    />
                    <Link
                      data-bs-toggle="modal"
                      data-backdrop="static"
                      data-keyboard="false"
                      className="btn btn-outline-dark mt-3"
                      onClick={() => handleShow()}
                    >
                      <IoMdAddCircle /> Add Category
                    </Link>
                  </div>
                </div>

                {/* Add Categories Model */}
                <Modal show={show} onHide={handleClose} className="modal-lg">
                  <Modal.Header>
                    <Modal.Title>Add Category </Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesformodel}
                    validationSchema={validationSchemaformodel}
                    onSubmit={handleSubmitformodel}
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form>
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <div className="col-md-3">
                              <label className="form-label">
                                Parent Category
                              </label>
                            </div>
                            <div className="col-md-9 mb-3">
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isClearable={true}
                                onChange={setselectedParentCategory}
                                options={ParentCategoryOption}
                                placeholder=""
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                value={selectedParentCategory}
                                id="ParentID"
                                name="ParentID"
                                className="w-100"
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Name
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="CategoryName"
                                id="CategoryName"
                                className={` ${
                                  errors.CategoryName ? "is-invalid" : ""
                                }`}
                                placeholder="Enter Category Name"
                                value={values.CategoryName}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback">
                                {touched.CategoryName && errors.CategoryName
                                  ? errors.CategoryName
                                  : ""}
                              </div>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Color
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="color"
                                name="Color"
                                className={`form-control form-control-color`}
                                value={values.Color}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Image
                            </label>
                            <div className="col-md-9 mt-2">
                              <FileInput
                                id="SelectImage"
                                name="SelectImage"
                                value={selectedImage}
                                accept="image/*"
                                handleChange={_handleFileChange}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3">
                              Default Hide From Grid
                            </label>
                            <div className="col-md-9">
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isMulti={true}
                                isClearable={true}
                                onChange={handleItemKitsIds}
                                options={itemkitsOption}
                                placeholder=""
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                value={itemkitsOption.filter((obj) =>
                                  selectedItems.includes(obj.value)
                                )}
                                id="ItemIds"
                                name="ItemIds"
                                className="w-100"
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Information Popup When Adding To Sale
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                as="textarea"
                                name="CategoryInfopopup"
                                className={`form-control`}
                                rows={5}
                                cols={5}
                                value={values.CategoryInfopopup}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-primary btn-md me-2"
                            >
                              Submit
                            </button>

                            <button
                              className="btn btn-dark btn-md me-1"
                              onClick={handleClose}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Add Secondary Button */}

                {category.map((data, index) => {
                  const { ID, CategoryId } = data;
                  return (
                    <div key={index}>
                      <input type="hidden" name="ID" value={ID} />
                      <div className="row mt-3">
                        <label className="col-form-label col-md-1">
                          Secondary Category
                        </label>
                        <div className="col-md-11">
                          <Select
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            onChange={(event) =>
                              handleChangeforDropdon(index, event)
                            }
                            options={Catagories}
                            placeholder=""
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            value={Catagories.find(
                              (option) =>
                                option.value === category[index].CategoryId
                            )}
                            id="CategoryId"
                            name="CategoryId"
                            className="w-100"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="row">
                  <div className="col-md-1 mb-3 mt-1"></div>
                  <div className="col-md-11 mt-3 mb-3">
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      onClick={addCategory}
                    >
                      <IoMdAddCircle /> Add Secondary Category
                    </button>
                  </div>
                </div>

                {/* Supplier */}
                {supplier?.map((data, index) => {
                  const { ID, SupplierId } = data;
                  return (
                    <div key={index}>
                      <input type="hidden" name="ID" value={ID} />
                      <div className="row mt-2">
                        <label className="form-label col-md-1">Supplier</label>
                        <div className="col-md-11 mb-3">
                          <Select
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            onChange={(event) =>
                              handleChangeforDropdonsuppliers(index, event)
                            }
                            options={Supplierlist}
                            placeholder=""
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            value={Supplierlist.find(
                              (option) =>
                                option.value === supplier[index].SupplierId
                            )}
                            id="SupplierId"
                            name="SupplierId"
                            className="w-100"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                {/* Add Supplier Button */}
                <div className="row">
                  <div className="col-md-1 mb-3 mt-1"></div>
                  <div className="col-md-11 mb-3 mt-1">
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      onClick={addSupplier}
                    >
                      <IoMdAddCircle /> Add Supplier
                    </button>
                  </div>
                </div>

                {ItemFieldshow === false && (
                  <>
                    {/* Modifiers */}
                    <div className="card mt-3">
                      <div className="card-header">
                        <h5 className="card-title">
                          <img src={Product} alt="img" /> Modifiers
                        </h5>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {/* {Modifiers.map((item, index) => {
                            return (
                              <div
                                key={item.ID}
                                className="col-md-3 col-sm-6 mb-3"
                              >
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{
                                      width: "1.25em",
                                      height: "1.25em",
                                    }}
                                    onChange={(evnt) => {
                                      handleCheck(index, evnt, item.ID);
                                    }}
                                    value={item.ID}
                                    defaultChecked={check.includes(item.ID)}
                                  />
                                  <label className={isCheck(item.ID)}>
                                    {item.Name}
                                  </label>
                                </div>
                              </div>
                            );
                          })} */}
                          {Modifiers.map((item, index) => (
                            <div
                              key={item.ID}
                              className="col-md-3 col-sm-6 mb-3"
                            >
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  onChange={(evnt) =>
                                    handleCheck(index, evnt, item.ID)
                                  }
                                  style={{
                                    width: "1.25em",
                                    height: "1.25em",
                                  }}
                                  value={item.ID}
                                  defaultChecked={check.includes(item.ID)}
                                />
                                <label className={isCheck(item.ID)}>
                                  {item.Name}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="text-center">
                      {props.currentStep > 1 && (
                        <button
                          onClick={handleBack}
                          className="btn btn-primary me-3"
                        >
                          Back
                        </button>
                      )}
                      {props.currentStep < props.totalSteps && (
                        <button
                          //onClick={handleNext}
                          className="btn btn-primary"
                          id="btn2"
                          type="submit"
                          data-page="specific-page"
                          ref={buttonRef}
                        >
                          Next
                        </button>
                      )}
                    </div>
                  </>
                )}

                {/* Submit Button */}
                {ItemFieldshow === true && (
                  <div className="row">
                    <div className="col-lg-12 justify-content-right">
                      <button
                        type="submit"
                        className="btn btn-primary btn-md me-2"
                      >
                        Submit
                      </button>
                      <Link
                        to="/item-Kits"
                        className="btn btn-secondary btn-md me-1"
                      >
                        Cancel
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>
        <ActionButtons {...props} />
      </div>
    </>
  );
};

export default ItemInfo;
